import { createAction, props } from "@ngrx/store";
import { User } from "../../models/user.model";
import { MultimediaObject, Review } from "../../models/reviews.model";

export const LOAD_REVIEWS = '[Reviews] Load reviews';
export const LOAD_REVIEWS_SUCCESS = '[Reviews] Load reviews success';
export const LOAD_REVIEWS_FAIL = '[Reviews] Load reviews fail';
export const SEND_REVIEWS = '[Reviews] Send reviews';
export const SEND_REVIEWS_SUCCESS = '[Reviews] Send reviews success';
export const SEND_REVIEWS_FAIL = '[Reviews] Send reviews fail';

export const LoadReviewsAction = createAction(
    LOAD_REVIEWS,
    props<{ data: User }>()
);

export const LoadReviewsSuccessAction = createAction(
    LOAD_REVIEWS_SUCCESS,
    props<{ data: Review[] }>()
);

export const LoadReviewsFailAction = createAction(
    LOAD_REVIEWS_FAIL,
    props<{ error: Error }>()
);

export const SendReviewsAction = createAction(
    SEND_REVIEWS,
    props<{ review: Review; multimediaObjects: MultimediaObject[] }>()
);

export const SendReviewsSuccessAction = createAction(
    SEND_REVIEWS_SUCCESS,
    props<{ review: Review }>()
);

export const SendReviewsFailAction = createAction(
    SEND_REVIEWS_FAIL,
    props<{ error: Error }>()
);
